/* istanbul ignore file */
import { FormRow } from 'framework/ui/layout';
import { Box, Typography } from '@mui/material';
import { Switch, TextInput, TimezoneDropdown } from 'framework/form';
import CheckOutlined from '@mui/icons-material/CheckOutlined';
import { EmployeePhotoUploaderInput } from 'domain/shared/employee';

const SettingsForm = () => (
  <Box sx={{ width: '100%', maxWidth: 900 }}>
    <Typography color="secondary" variant="subtitle1" mb={2}>
      Public information
    </Typography>

    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '0.2fr 0.9fr' }, gap: { xs: 0, sm: 3 } }}>
      <EmployeePhotoUploaderInput
        source="photosIds"
        label=""
        maxElements={1}
        uploadBtnText="Click to upload or drag file"
      />

      <Box sx={{ mb: { xs: 2, sm: 0 } }}>
        {['use a recent photo', 'you should be the only subject in the photo', 'your face should be in focus'].map(
          text => (
            <Box key={text} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, fontSize: 14 }}>
              <CheckOutlined sx={{ color: 'success.main', fontSize: 20 }} />
              {text}
            </Box>
          ),
        )}
      </Box>
    </Box>

    <FormRow>
      <TimezoneDropdown label="Time zone" source="timezone" sx={{ mb: '5 !important' }} />
    </FormRow>

    <Typography color="secondary" variant="body2" fontWeight={300} mb={1}>
      Interview limits per day
    </Typography>
    <FormRow>
      <TextInput source="generalInterviewLimitPerDay" label="General" />
      <TextInput source="screeningInterviewLimitPerDay" label="Screenings" />
      <TextInput source="technicalInterviewLimitPerDay" label="Other (e.g. additional, role-related)" />
    </FormRow>

    <Box sx={{ mt: 1.5 }}>
      <Typography color="secondary" variant="subtitle1" mb={1}>
        Private information
      </Typography>
      <Typography color="textSecondary" variant="body2" mb={3.5}>
        This data will be available for people managers and HR specialists only
      </Typography>

      <FormRow>
        <TextInput source="extendedInformation.personalPhoneNumber" label="Personal phone number" />
        <TextInput source="extendedInformation.personalEmail" label="Personal email address" />
      </FormRow>

      <Switch
        sx={{ mt: 2 }}
        source="extendedInformation.birthdayCongratsConsent"
        label="I agree to be congratulated on my birthday in the Teams channel"
      />
    </Box>
  </Box>
);

export default SettingsForm;
